<template>
  <div class="logs">
    <div class="page-container">
      <PageHeader :title="title" />

      <div class="logs__filter-wrap">
        <div class="logs__filter app-filter">
          <div class="form-group">
            <label for="FilterSelect">{{ getMessageByLang('from', 'От' )}}</label>
            <div class="app-datepicker-block">
              <DatePicker v-model="filter.date_from" name="date_from" @change="onChangeDate" v-if="isShowDatePicker" />
            </div>
          </div>
          <div class="form-group">
            <label for="FilterSelect">До</label>
            <DatePicker v-model="filter.date_to" name="date_to" @change="onChangeDate" v-if="isShowDatePicker" />
          </div>
          <div class="form-group">
            <label>Пользователь</label>
            <select
              id="FilterUser"
              class="app-select"
              v-model="filter.user_id"
              @change="onChangeFilter"
            >
              <option :value="null">
                {{ getMessageByLang("AllText", "Все") }}
              </option>
              <option v-for="user in users" :key="user.id" :value="user.id">
                {{ user.name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="FilterSelect">Действие</label>
            <select
              id="FilterSelect"
              class="app-select"
              @change="handleChangeFilterAction($event)"
            >
              <option :value="null">
                {{ getMessageByLang("AllText", "Все") }}
              </option>
              <option
                v-for="action in actions"
                :key="action.key"
                :value="action.key"
              >
                {{ action.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="logs__filter__control">
          <Button :theme-color="'primary'" @click="clearFilter"
            >{{ getMessageByLang("clearTExt", "Очистить") }}
          </Button>
        </div>
      </div>

      <VLoader v-if="isLoading" />
      <div v-else>
        <Grid ref="grid" :data-items="logs" :columns="columns">
          <template v-slot:user="{ props }">
            <td class="k-command-cell k-table-td">
              {{ props?.dataItem?.user?.name || "" }}
            </td>
          </template>

          <template v-slot:created_at="{ props }">
            <td class="k-command-cell k-table-td">
              {{ moment(props.dataItem.created_at).format("DD.MM.YYYY HH:ss") }}
            </td>
          </template>

          <template v-slot:action="{ props }">
            <td class="k-command-cell k-table-td">
              {{ renderAction(props.dataItem.action) }}
            </td>
          </template>

          <template v-slot:user_type="{ props }">
            <td class="k-command-cell k-table-td">
              {{ getNameRole(props.dataItem.user_type) }}
            </td>
          </template>

          <template v-slot:entity="{props}">
            <td class="k-command-cell k-table-td">
              {{ renderEntity(props.dataItem) }}
            </td>
          </template>

          <template v-slot:control="{ props }">
            <td class="k-command-cell k-table-td">
              <div class="cell-control">
                <Button
                  :title="getMessageByLang('editText', 'Подробнее')"
                  :svg-icon="eyeIcon"
                  @click="showDetails(props.dataItem.id)"
                >
                </Button>
              </div>
            </td>
          </template>
          <GridNoRecords>Нет данных</GridNoRecords>
        </Grid>
      </div>
    </div>
  </div>
</template>



<script setup>
import {ref, onMounted} from "vue";
import { useRouter } from "vue-router";
import moment from "moment";
import { getNameRole } from "@/utils/user.js";
import { getRole } from "@/utils/router";
import { mapActions, mapEntity, actions} from '@/constants/app';
import { isInvalidRange } from '@/utils/date.js';

import { Grid, GridNoRecords } from "@progress/kendo-vue-grid";
import { DatePicker } from "@progress/kendo-vue-dateinputs";
import { eyeIcon } from "@progress/kendo-svg-icons";
import { Button } from "@progress/kendo-vue-buttons";

import { getMessageByLang } from "@/utils/translate.js";

import VLoader from "@/ui-kit/components/VLoader";
import PageHeader from "@/components/page/PageHeader.vue";

import api from "@/api";

const logs = ref([]);
const isLoading = ref(true);
const title = "Журнал событий";
const isShowDatePicker = ref(true);
const router = useRouter();

const columns = [
  {
    field: "created_at",
    title: "дата",
    cell: "created_at",
  },
  {
    field: "user",
    title: "Пользователь",
    cell: "user",
  },
  {
    field: "action",
    title: "Действие",
    cell: 'action'
  },
  {
    field: 'entity',
    cell: 'entity',
    title: 'Предмет'
  },
  {
    field: "user_type",
    title: "Роль",
    cell: "user_type",
  },
  {
    field: "control",
    title: "Управление",
    cell: "control",
    width: '150px'
  },
];
const filter = ref({
  date_from: new Date(new Date().setDate(new Date().getDate() - 1)),
  date_to: new Date()
});

const users = ref([]);

const updateDatePicker = () => {
  isShowDatePicker.value = false;

  setTimeout(() => {
    isShowDatePicker.value = true;
  }, 0);
}

const clearFilter = () => {
  filter.value = {
    date_from: new Date(new Date().setDate(new Date().getDate() - 1)),
    date_to: new Date()
  };
  updateDatePicker();
  getLogs();
}

const onChangeDate = (date) => {
  if(date.target.name === 'date_from') {
    if(!filter.value.date_to) {
      filter.value.date_from = new Date()
    }

    if(!isInvalidRange(filter.value.date_from, filter.value.date_to)) {
      filter.value.date_to = new Date(filter.value.date_from);
    }
  }

  getLogs();
}

const showDetails = (logId) => {
  router.push(`/${getRole()}/logs/${logId}`);
};

const onChangeFilter = (prop, value) => {
  filter.value[prop] = value;
  getLogs();
};

const handleChangeFilterAction = (event) => {
  let value = event.target.value
  if(value === 'Все') {
    value = null;
  }

  filter.value.action = value;
  getLogs();
}

const renderEntity = (item) => {
  if(!item.entity_type) return '-';

  const str = item.entity_type.split('\\');
  const entity = str[str.length - 1];
  return mapEntity[entity] || ''
}

const renderAction = (action) => {
  return mapActions[action] || ''
}

const getLogs = async () => {
  try {
    isLoading.value = true;

    console.log('filter', filter.value)

    const { data } = await api.logs.getList(filter.value);
    logs.value = data.data;

  } catch (err) {
    console.error(err);
    logs.value = [];
  } finally {
    isLoading.value = false;
  }
};

const getUsers = async () => {
  const { data } = await api.users.getList();

  users.value = data.data;
};

onMounted(() => {
  getLogs();
  getUsers();
});
</script>

<style lang="scss" scoped>
.logs {
  &__filter {
    margin-bottom: 1rem;

    &__control {
      display: flex;
      justify-content: flex-end;
    }
  }

  &__link {
    color: #ff4081;
  }

  &__filter-wrap {
    display: flex;
    flex-direction: column;
    gap: .5rem;
  }
}
</style>